import { render, staticRenderFns } from "./WriteOffPage.vue?vue&type=template&id=0b0a5ed2&scoped=true&"
import script from "./WriteOffPage.vue?vue&type=script&lang=ts&"
export * from "./WriteOffPage.vue?vue&type=script&lang=ts&"
import style0 from "./WriteOffPage.vue?vue&type=style&index=0&id=0b0a5ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a5ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VProgressCircular,VRow,VSheet,VSimpleTable,VTextarea})
